import { useEntitlements } from '@admin/shared/contexts/EntitlementsContext';
import { getSubscriptionFeatures, normalizeTier } from '@app/utils/tierUtils';

export const useSubscriptionFeatures = () => {
  const { subscription, isLoading, refreshEntitlements } = useEntitlements();
  const tier = normalizeTier(subscription?.tier ?? 'free');

  return {
    tier,
    features: getSubscriptionFeatures(tier),
    isLoading,
    refreshEntitlements,
  };
};
